<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  page: { type: Number, default: 1 },
  totalPages: { type: Number, default: 0 },
  totalRows: { type: Number, default: 0 },
  shownRows: { type: Number, default: 0 },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['toggleFilters', 'toggleOrder', 'changePage']);
const { t } = useI18n();
</script>

<template>
  <div
    class="flex min-h-[50px] items-center justify-between gap-4 px-[13px] py-2 font-[Roboto] max-md:min-h-[112px]"
  >
    <div class="flex items-center gap-5">
      <button
        type="button"
        class="flex items-center gap-2 text-base font-bold text-[#464F53] hover:text-[#01988C]"
        :disabled="isLoading"
        @click="emit('toggleFilters')"
      >
        <span
          class="i-heroicons-funnel-solid size-5 text-[#01988C]"
          aria-hidden="true"
        />
        {{ t('REAL_ESTATE_COMMISSION_SUPPORT.ACTIONS.FILTER') }}
      </button>
      <button
        type="button"
        class="flex items-center gap-2 text-base font-bold text-[#464F53] hover:text-[#01988C]"
        :disabled="isLoading"
        @click="emit('toggleOrder')"
      >
        <span
          class="i-heroicons-bars-arrow-down-solid size-5 text-[#01988C]"
          aria-hidden="true"
        />
        {{ t('REAL_ESTATE_COMMISSION_SUPPORT.ACTIONS.ORDER') }}
      </button>
    </div>
    <div class="flex min-w-0 items-center gap-3 text-sm text-[#464F53]">
      <span>
        {{
          t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.SHOWING', {
            shown: shownRows,
            total: totalRows,
          })
        }}
      </span>
      <button
        type="button"
        class="grid size-7 place-items-center text-xl text-[#8DD8D1] disabled:opacity-40"
        :disabled="isLoading || page <= 1"
        :aria-label="t('REAL_ESTATE_COMMISSION_SUPPORT.ACTIONS.PREVIOUS')"
        @click="emit('changePage', page - 1)"
      >
        <span class="i-lucide-chevron-left size-4" aria-hidden="true" />
      </button>
      <span
        class="grid size-8 place-items-center rounded-[10px] bg-[#EDF8F7] font-bold text-[#01988C]"
      >
        {{ page }}
      </span>
      <button
        type="button"
        class="grid size-7 place-items-center text-xl text-[#8DD8D1] disabled:opacity-40"
        :disabled="isLoading || page >= totalPages || !totalPages"
        :aria-label="t('REAL_ESTATE_COMMISSION_SUPPORT.ACTIONS.NEXT')"
        @click="emit('changePage', page + 1)"
      >
        <span class="i-lucide-chevron-right size-4" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>
